import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PopUpComponent } from '../components/pop-up/pop-up.component';
import { SosAlertComponent } from '../components/sos-alert/sos-alert.component';
import { ShowAlertInfoComponent } from '../components/show-alert-info/show-alert-info.component';
import { ShowMapInfoComponent } from '../components/show-map-info/show-map-info.component';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import {FormModalComponent} from '../components/form-modal/form-modal.component';
import {FormQuestionnaireComponent} from '../components/form-questionnaire/form-questionnaire.component';
import {CaregiverService} from './caregiver.service';
import {PopUpHtmlComponent} from '../components/pop-up-html/pop-up-html.component';
import {GuestAlertComponent} from '../components/guest-alert/guest-alert.component';
import { DatePipe } from '@angular/common';

@Injectable()
export class ModalService {

    private isActiveAlert: boolean;
    private turnOnAlerts = true;

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private translate: TranslateService,
        private caregiverService: CaregiverService,
        private datePipe: DatePipe
    ) { }

    open(message: string, route?: string, fontSize = 'big') {
        setTimeout(() => {
            const modalRef = this.modalService.open(PopUpComponent, { centered: true, backdrop: 'static', keyboard: false });
            modalRef.componentInstance.modalType = 1;
            modalRef.componentInstance.message = message;
            modalRef.componentInstance.fontSize = fontSize;

            if (route && route !== '') {
                modalRef.result.then((result) => {
                    this.router.navigateByUrl(route);
                });
            }
        });
    }

    openRaw(message: string) {
      setTimeout(() => {
        const modalRef = this.modalService.open(PopUpComponent, { centered: true, backdrop: 'static', keyboard: false });
        modalRef.componentInstance.modalType = 69;
        modalRef.componentInstance.message = message;
      });
    }

    openMailSend(message: string, route?: string) {
        setTimeout(() => {
            const modalRef = this.modalService.open(FormModalComponent, { centered: true, backdrop: 'static', keyboard: true });
            modalRef.componentInstance.modalType = 1;
            modalRef.componentInstance.message = message;
            modalRef.componentInstance.mail = message;

            if (route) {
                modalRef.result.then((result) => {
                    this.router.navigateByUrl(route);
                });
            }
        });
    }

    openQuestionnareSend(message: string, route?: string) {
        setTimeout(() => {
            const modalRef = this.modalService.open(FormQuestionnaireComponent, { centered: true, backdrop: 'static', keyboard: true });
            modalRef.componentInstance.modalType = 1;
            modalRef.componentInstance.message = message;

            if (route) {
                modalRef.result.then((result) => {
                    this.router.navigateByUrl(route);
                });
            }
        });
    }

    openAccept(message: string): Observable<any> {
        const response: Subject<any> = new Subject<any>();

        setTimeout(() => {

            const modalRef = this.modalService.open(PopUpComponent, { centered: true, backdrop: 'static', keyboard: false });
            modalRef.componentInstance.modalType = 2;
            modalRef.componentInstance.message = message;

            modalRef.result.then(
                (result) => response.next({ ok: true })
            ).catch(
                (reject) => response.next({ ok: false })
            );

        });
        return response;
    }

    openGuestAlert(data) {
      if (this.turnOnAlerts) {
        if (!this.isActiveAlert) {
          this.isActiveAlert = true;
          setTimeout(() => {
            const modalRef = this.modalService.open(GuestAlertComponent, {centered: true, backdrop: 'static', keyboard: false});
            modalRef.componentInstance.data = data;

            modalRef.result.then((res) => {
              this.openAccept('Czy odebrać alarm połączenia z zewnątrz?')
                .pipe(take(1))
                .subscribe(datum => {
                  if (datum.ok === true) {
                    this.isActiveAlert = false;
                    this.router.navigateByUrl('/users/guest-call/' + data.phoneNumber + '/' + data.data['callHistoryId']);
                  }
                });
            }, (reject) => {
              this.isActiveAlert = false;
            });
          });
        }
      }
    }

    openSosAlert(user) {

        if(this.turnOnAlerts) {
            if (!this.isActiveAlert) {
                this.isActiveAlert = true;
                setTimeout(() => {
                    const modalRef = this.modalService.open(SosAlertComponent, {centered: true, backdrop: 'static', keyboard: false});
                    modalRef.componentInstance.user = user;

                    modalRef.result.then((result) => {
                        this.openAccept(
                            this.translate.instant('BACKEND.ACCEPT-REQUEST-' + user.discr, {
                                lastname: user.last_name,
                                firstname: user.first_name
                            })
                        )
                            .pipe(take(1))
                            .subscribe(data => {
                                if (data.ok === true) {
                                    this.isActiveAlert = false;
                                    this.router.navigateByUrl('/users/sos-request/' + user.alarmID);

                                }
                            });
                    }, (reject) => {
                        this.isActiveAlert = false;
                    });

                });
            }
        }
    }



    turnOffAlert(status)  {
        this.turnOnAlerts = status;
    }

    openAlertInfo(data, bandType, type) {
      console.log(type);
        setTimeout(() => {
            const modalRef = this.modalService.open(ShowAlertInfoComponent, { backdrop: 'static', keyboard: false });
            modalRef.componentInstance.data = data;
            modalRef.componentInstance.bandType = bandType;
            modalRef.componentInstance.type = type;
        });
    }


    openMapInfo(data) {
        setTimeout(() => {
            const modalRef = this.modalService.open(ShowMapInfoComponent, { centered: true, backdrop: 'static', keyboard: false });
            modalRef.componentInstance.data = data;
        });
    }

    openStartInfo(message: string, route?: string) {
      setTimeout(() => {
        const modalRef = this.modalService.open(PopUpHtmlComponent, { centered: true, backdrop: 'static', keyboard: false });
        modalRef.componentInstance.modalType = 1;
        modalRef.componentInstance.message = message;

        if (route) {
          modalRef.result.then((result) => {
            this.router.navigateByUrl(route);
          });
        }
      });
    }

    openUnauthorized(message?: string) {
      setTimeout(() => {
        const modalRef = this.modalService.open(PopUpComponent, { centered: true, backdrop: 'static', keyboard: false });
        modalRef.componentInstance.modalType = 1;
        modalRef.componentInstance.message = message || this.translate.instant('BACKEND.UNAUTHORIZED-ACCESS');

        modalRef.result.then((result) => {
          this.router.navigateByUrl('/caregivers/telecare');
        });
      });
    }

    openAudioPlayer(audioUrl: string, record: any) {
      setTimeout(() => {
        const modalRef = this.modalService.open(PopUpHtmlComponent, { centered: true, size: 'lg' });
        modalRef.componentInstance.modalType = 1;

        const startDate = this.datePipe.transform(record.start, 'yyyy-MM-dd HH:mm');
        const endDate = this.datePipe.transform(record.stop, 'yyyy-MM-dd HH:mm');

        modalRef.componentInstance.message = `
          <div style="text-align: center; padding: 20px;">
            <h4 style="margin-bottom: 20px;">Odtwarzacz nagrania</h4>
            <div style="margin-bottom: 20px; color: #666; text-align: left; max-width: 600px; margin-left: auto; margin-right: auto;">
              <p style="margin: 8px 0;"><strong>Początek:</strong> ${startDate}</p>
              <p style="margin: 8px 0;"><strong>Koniec:</strong> ${endDate}</p>
              <p style="margin: 8px 0;"><strong>Numer odbierającego:</strong> ${record.userPhone}</p>
            </div>
            <audio controls autoplay style="width: 100%; max-width: 600px;">
              <source src="${audioUrl}" type="audio/mpeg">
              <source src="${audioUrl}" type="audio/wav">
              Twoja przeglądarka nie obsługuje odtwarzacza audio.
            </audio>
          </div>
        `;
      });
    }

    openAcceptHtml(message: string): Observable<any> {
        const response: Subject<any> = new Subject<any>();

        setTimeout(() => {
            const modalRef = this.modalService.open(PopUpHtmlComponent, { centered: true, backdrop: 'static', keyboard: false, size: 'lg' });
            modalRef.componentInstance.modalType = 2;
            modalRef.componentInstance.message = message;

            modalRef.result.then(
                (result) => response.next({ ok: true })
            ).catch(
                (reject) => response.next({ ok: false })
            );
        });
        return response;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/modal.service.ts